import { gql } from 'graphql-request'
import graphQLRequest from 'CanExConfig/graphQLRequest'

const CREATE_CANDIDATE_REGIONAL_CITIZENSHIP = gql`
  mutation createCandidateRegionalCitizenship($input: CreateCandidateRegionalCitizenshipInput!) {
    createCandidateRegionalCitizenship(input: $input) {
      regionalCitizenship {
        id
        citizenshipStatus
        countryIso2Code
        countryName
        description
        permitType
      }
    }
  }
`

const UPDATE_CANDIDATE_REGIONAL_CITIZENSHIP = gql`
  mutation updateCandidateRegionalCitizenship($input: UpdateCandidateRegionalCitizenshipInput!) {
    updateCandidateRegionalCitizenship(input: $input) {
      regionalCitizenship {
        id
        citizenshipStatus
        countryIso2Code
        countryName
        description
        permitType
      }
    }
  }
`

const DELETE_CANDIDATE_REGIONAL_CITIZENSHIP = gql`
  mutation deleteCandidateRegionalCitizenship($input: DeleteCandidateRegionalCitizenshipInput!) {
    deleteCandidateRegionalCitizenship(input: $input) {
      regionalCitizenship {
        id
      }
    }
  }
`

export const createCitizenshipStatus = citizenships =>
  Promise.all(
    citizenships.map(citizenship =>
      graphQLRequest(CREATE_CANDIDATE_REGIONAL_CITIZENSHIP, {
        input: citizenship,
      }),
    ),
  )

export const updateCitizenshipStatus = citizenships =>
  Promise.all(
    citizenships.map(citizenship =>
      graphQLRequest(UPDATE_CANDIDATE_REGIONAL_CITIZENSHIP, {
        input: citizenship,
      }),
    ),
  )

export const deleteCitizenshipStatus = citizenship => graphQLRequest(DELETE_CANDIDATE_REGIONAL_CITIZENSHIP, { input: citizenship })

export const deleteManyCitizenshipStatuses = citizenshipIds =>
  Promise.all(citizenshipIds.map(id => graphQLRequest(DELETE_CANDIDATE_REGIONAL_CITIZENSHIP, { input: { id } })))
